/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOkFromDiscriminatorValue, serializeDeactivateSalesRepRequest, serializeOk, type DeactivateSalesRepRequest, type ErrorResponse, type InternalErrorResponse, type Ok } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/salesreps/deactivate
 */
export interface DeactivateRequestBuilder extends BaseRequestBuilder<DeactivateRequestBuilder> {
    /**
     * Deactivates a Sales Rep in the Organization.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: DeactivateSalesRepRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Deactivates a Sales Rep in the Organization.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: DeactivateSalesRepRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DeactivateRequestBuilderUriTemplate = "{+baseurl}/api/organizations/salesreps/deactivate";
/**
 * Metadata for all the requests in the request builder.
 */
export const DeactivateRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: DeactivateRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeactivateSalesRepRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
